import React from 'react'
import { Box } from '@mui/material'
import { TV_COLORS } from '../designSystem'

const GameBackdrop = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      width: '100%',
      minHeight: '100%',
      background: 'radial-gradient(circle at top, rgba(255,214,0,0.15), transparent 45%), linear-gradient(140deg, #060616 0%, #0d0b20 50%, #030307 100%)',
      padding: 3,
      borderRadius: 3,
      boxShadow: '0 0 40px rgba(0,0,0,0.45)',
      position: 'relative',
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.15,
        pointerEvents: 'none',
        backgroundImage: `repeating-linear-gradient(135deg, transparent, transparent 10px, rgba(255,255,255,0.05) 10px, rgba(255,255,255,0.05) 12px)`,
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        inset: 20,
        border: `1px solid rgba(255,255,255,0.08)`,
        borderRadius: 3,
        boxShadow: `0 0 30px rgba(30,136,229,0.15)`,
        pointerEvents: 'none',
      }}
    />
    <Box sx={{ position: 'relative', zIndex: 1 }}>{children}</Box>
  </Box>
)

export default GameBackdrop
